<template>
  <div class="dashboard-container">
    <el-row type="flex" :gutter="10" justify="end">
      <el-col :span="24">
        <div class="el-col-box chart">
          <date />
        </div>
      </el-col>
    </el-row>
    <!-- <el-row type="flex" :gutter="10" justify="end">
      <el-col :span="24">
        <div class="el-col-box chart">
          <scan-times ref="scanTimes" />
        </div>
      </el-col>
    </el-row>
    <el-row
      :type="isMB?'':'flex'"
      :gutter="10"
      justify="end"
      :style="isMB?'margin-bottom:20px;':''"
    >
      <el-col :span="isMB?24:12" :style="isMB?'margin-bottom:20px;':''">
        <div class="el-col-box" :style="isMB?'height:270px':''">
          <div>
            <statistics ref="statistics" />
          </div>
        </div>
      </el-col>
      <el-col :span="isMB?24:12">
        <div class="el-col-box" :style="isMB?'height:300px':''">
          <div>
            <chart />
          </div>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import date from "@/components/dashboard/cards/date";
import scanTimes from "@/components/dashboard/cards/scanTimes";
import statistics from "@/components/dashboard/cards/statistics";
import chart from "@/components/dashboard/cards/chart";

export default {
  name: "home",
  components: {
    date,
    scanTimes,
    statistics,
    chart,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require("@/api/web/article").default,
      timer: null,
    };
  },
  mounted() {
    // this.getTimesFn();
    // let self = this;
    // this.timer = setInterval(function () {
    //   self.getTimesFn();
    // }, 60000);

    // if (window.addEventListener) {
    //   //所有主流浏览器，除了 IE 8 及更早 IE版本
    //   window.addEventListener("keyup", this.handleFunc);
    //   window.addEventListener("scroll", this.handleFunc);
    //   window.addEventListener("mousemove", this.handleFunc);
    //   window.addEventListener("click", this.handleFunc);
    // } else if (window.attachEvent) {
    //   // IE 8 及更早 IE 版本
    //   window.attachEvent("keyup", this.handleFunc);
    //   window.attachEvent("scroll", this.handleFunc);
    //   window.attachEvent("mousemove", this.handleFunc);
    //   window.attachEvent("click", this.handleFunc);
    // }
  },
  methods: {
    getTimesFn() {
      if (this.$store.state.user.interval != null) {
        this.api.getIndexStat().then((res) => {
          if (res.Data) {
            if (this.$refs.scanTimes) {
              this.$refs.scanTimes.setData(res.Data.ViewNumber);
            }
            if (this.$refs.statistics) {
              this.$refs.statistics.setData(res.Data);
            }
          }
        });
      } else {
        if (this.timer) clearInterval(this.timer); //关闭
      }
    },
    //监听事件
    handleFunc(event) {
      this.$store.dispatch("setActiveTime", new Date());
    },
  },
};
</script>
<style  lang="scss" scoped>
.dashboard-container {
  padding: 32px 35px 15px;
  background-color: rgb(240, 242, 245);
  position: relative;
  height: calc(100vh - 84px);
  overflow: auto;
  .el-row {
    margin-bottom: 20px;
    @media (max-width: 480px) {
      margin-top: 20px;
    }
  }
}
.el-col-box {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: 350px;
  @media screen and (max-width: 767px) {
    min-height: 250px;
  }
}
.cName {
  font-size: 20px;
  color: #0198ff;
  letter-spacing: 3px;
  // font-weight: bold;
  text-align: center;
  // img{
  //   vertical-align:middle;
  //   margin-right: 10px;
  //   height: 40px;
  // }
}
.el-col {
  padding: 0 8px !important;
}
</style>